import type { App } from 'vue'

import { createRouter, createWebHistory } from 'vue-router'

import { protectedRoutes } from './protected'
import { publicRoutes } from './public'
import { setupPageGuard } from './permission'

const routes = [...protectedRoutes, ...publicRoutes]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

setupPageGuard(router)

export async function reSetRputer(app: App) {
}

export async function setupRouter(app: App) {
  app.use(router)
  await router.isReady()
}
